var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1ShutterClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v50h29V13H40zm25 39H44v-3h21v3zm0-8H44v-3h21v3zm0-8H44v-3h21v3zm0-8H44v-3h21v3zM7 63h29V13H7v50zm4-38h21v3H11v-3zm0 8h21v3H11v-3zm0 8h21v3H11v-3zm0 8h21v3H11v-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Shutter_close.91b6955e.svg";
export { SvgC1ShutterClose as ReactComponent };